// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  // console.log("Item added to the cart");
  // console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  // console.log("Cart updated");
  // console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  // console.log("Quick cart opened");
  // console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  // console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  // console.log("Product variant changed");
  // console.log(evt.detail.variant);

  /*
  let buyButtons = document.querySelector("#product-form__buy-buttons")

  var product_warningLabel = document.getElementById('product__warning');
  if (evt.detail.variant.option1.includes("Family Friendly") || evt.detail.variant.option2.includes("Family Friendly")) {
    product_warningLabel.innerHTML = "<p>Family Friendly: Ages 11+ with adult (18+) supervision.</p><p>All guests (including adult supervision) require a ticket.</p><p>One adult can bring a maximum of two children.</p>"; //"<p>These classes are family-friendly, whereby, children over the age of 11 are welcome to attend with adult supervision. The adult-to-child ratio must be one adult for every two children. All attendees (including adult supervisors) must purchase a ticket.</p>";
  } else {
      product_warningLabel.innerHTML = "";
  }
  */
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  // console.log("Product quantity updated");
  // console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  // console.log("Quickview loaded");
});


if(window.location.href.includes('event-facilitator-guide')) {
  var doc = document.querySelector('#facilitator__doc');
  doc.setAttribute('src',`https://docs.google.com/document/d/13z4hueQ09CbjyiQa17YNGsNeHbH3_SN4SYL-J2Ogx14/preview`);
}

(function () {
  const MEMBERSHIP_PRODUCT_MATCH = 'SPHERE MEMBERSHIP';

  function isMembershipItem(item) {
    const productTitle = (item.product_title || '').toUpperCase();
    return productTitle.includes(MEMBERSHIP_PRODUCT_MATCH);
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  async function changeCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: key,
        quantity
      })
    });

    if (!res.ok) {
      throw new Error(`Failed to update cart item ${key}`);
    }

    return res.json();
  }

  function ensureQuickCartFocusFallback(quickCart) {
    let fallback = quickCart.querySelector('[data-quick-cart-focus-fallback]');

    if (!fallback) {
      fallback = document.createElement('button');
      fallback.type = 'button';
      fallback.setAttribute('data-quick-cart-focus-fallback', 'true');
      fallback.setAttribute('aria-hidden', 'true');
      fallback.tabIndex = 0;
      fallback.textContent = 'focus fallback';

      fallback.style.position = 'absolute';
      fallback.style.left = '-9999px';
      fallback.style.width = '1px';
      fallback.style.height = '1px';
      fallback.style.opacity = '0';
      fallback.style.pointerEvents = 'none';

      quickCart.appendChild(fallback);
    }

    return fallback;
  }

  function getQuickCartFocusableTarget(quickCart) {
    return quickCart.querySelector(
      '.quick-cart__close-icon, .quick-cart__submit, .quick-cart__item-remove, a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  async function refreshQuickCartSectionSafely() {
    const quickCart = document.querySelector('[data-section-type="quick-cart"]');
    if (!quickCart) return;

    const sectionId = quickCart.dataset.sectionId;
    if (!sectionId) {
      console.warn('Quick cart section found, but no section ID was available.');
      return;
    }

    const fallback = ensureQuickCartFocusFallback(quickCart);
    fallback.focus();

    await new Promise((resolve) => setTimeout(resolve, 0));

    const url = `${window.theme.routes.cart.base}?section_id=${sectionId}`;
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Failed to refresh quick cart section');

    const html = await response.text();
    const parsed = document.createElement('div');
    parsed.innerHTML = html;

    const sourceQuickCart = parsed.querySelector('[data-section-type="quick-cart"]');
    if (!sourceQuickCart) {
      console.warn('No quick cart section found in refreshed HTML.');
      return;
    }

    const targetContainer = quickCart.querySelector('.quick-cart__container');
    const sourceContainer = sourceQuickCart.querySelector('.quick-cart__container');

    if (!targetContainer || !sourceContainer) {
      console.warn('Quick cart container missing.');
      return;
    }

    targetContainer.innerHTML = sourceContainer.innerHTML;

    requestAnimationFrame(() => {
      const target = getQuickCartFocusableTarget(quickCart);
      if (target) {
        target.focus();
      } else {
        fallback.focus();
      }
    });
  }

  async function refreshCartPageSection() {
    const cartSection = document.querySelector('[data-section-type="cart"]');
    if (!cartSection) return;

    const sectionId =
      cartSection.dataset.sectionId ||
      cartSection.getAttribute('data-section-id');

    if (!sectionId) {
      console.warn('Cart section found, but no section ID was available.');
      return;
    }

    const url = `${window.theme.routes.cart.base}?section_id=${sectionId}`;
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Failed to refresh cart section');

    const html = await response.text();
    const parsed = document.createElement('div');
    parsed.innerHTML = html;

    const sourceCart = parsed.querySelector('[data-section-type="cart"]');
    if (!sourceCart) {
      console.warn('No cart section found in refreshed HTML.');
      return;
    }

    const sourceItems = sourceCart.querySelector('[js-cart-items]');
    const targetItems = cartSection.querySelector('[js-cart-items]');

    const sourceSubtotal = sourceCart.querySelector('[js-cart-footer-subtotal-wrapper]');
    const targetSubtotal = cartSection.querySelector('[js-cart-footer-subtotal-wrapper]');

    if (sourceItems && targetItems) {
      targetItems.innerHTML = sourceItems.innerHTML;
    }

    if (sourceSubtotal && targetSubtotal) {
      targetSubtotal.outerHTML = sourceSubtotal.outerHTML;
    }

    if ((!sourceItems || !targetItems) && sourceCart) {
      cartSection.innerHTML = sourceCart.innerHTML;
    }
  }

  async function refreshCartCount() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    const count = cart.item_count;

    document
      .querySelectorAll(
        '[data-js-cart-count], [data-cart-count], .cart-count-bubble, #cart-icon-bubble, [data-header-cart-count]'
      )
      .forEach((el) => {
        el.textContent = count;
      });
  }

  function showMembershipRemovedNotice() {
    return;
    if (document.querySelector('[data-membership-cart-notice]')) return;

    const notice = document.createElement('div');
    notice.setAttribute('data-membership-cart-notice', 'true');
    notice.textContent = 'Sphere Membership was removed from your cart. Please use the membership checkout link.';
    notice.style.padding = '12px 16px';
    notice.style.margin = '12px 0';
    notice.style.background = '#f5f5f5';
    notice.style.border = '1px solid #ddd';
    notice.style.fontSize = '14px';

    const quickCartContainer = document.querySelector('[data-section-type="quick-cart"] .quick-cart__container');
    const cartContainer = document.querySelector('[data-section-type="cart"]');

    if (cartContainer) {
      cartContainer.prepend(notice.cloneNode(true));
    }

    if (quickCartContainer) {
      quickCartContainer.prepend(notice);
    }
  }

  async function removeMembershipFromCart() {
    const cart = await getCart();
    const membershipItems = cart.items.filter(isMembershipItem);

    if (!membershipItems.length) return;

    for (const item of membershipItems) {
      await changeCartItem(item.key, 0);
    }

    await refreshQuickCartSectionSafely();
    await refreshCartPageSection();
    await refreshCartCount();
    showMembershipRemovedNotice();

    console.log('Removed Sphere Membership from cart because it must be purchased via checkout link.');
  }

  document.addEventListener('DOMContentLoaded', function () {
    removeMembershipFromCart().catch((err) => {
      console.error('Failed to remove Sphere Membership from cart', err);
    });
  });
})();